<template>
  <div id="tramiteNuevo">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary">drag_indicator</v-icon>
              </template>
              <span>Menú Principal</span>
            </v-tooltip>Trámite / Nuevo
          </h4>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-data-table
        :headers="headers"
        :loading="loading"
        :items="tipo_tramite"
        class="elevation-1"
        hide-actions
        v-cloak
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.flujo_tipo.flujo }}</td>
          <td>
            <v-btn
              depressed
              outline
              icon
              dark
              color="primary"
              small
              @click="goPage(props.item.flujo_tipo_id)"
            >
              <v-icon small>send</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="3000"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Service from "../services/general";
import axios from "axios";
export default {
  name: "tramite-nuevo",
  data: () => ({
    headers: [
      { text: 'Nro', align: 'left', sortable: false },
      { text: 'Trámite ', sortable: false, value: 'descripcion' },
      { text: 'Acciones', sortable: false, width: '18%' }
    ],
    loading: false,
    dialog: false,
    tipo_tramite: [],
    snack: {
      state: false,
      color: "success",
      mode: "",
      text: ""
    }
  }),
  mounted() {
    Service.removeTramiteId();
    this.dparams = Service.getParams(); 
    
    if (this.dparams != null) {
      this.getTipoTramites();
    }
    // this.tipo_tramite = [
    //   {id: 1, descripcion: 'Trámites CCTP', ruta: 'inicio'},
    // ];
  },
  methods: {
    getTipoTramites() {
      this.loading = true;
      this.dparams.tipo = 1; //Nuevo

      axios
        .post(Service.getServe() + "tramite/lista", this.dparams, Service.getHeader())
        .then(response => {
          this.loading = false;
          this.tipo_tramite = response.data.entities
          /* for (const key in response.data.entities) {
            if (response.data.entities[key].flujo_tipo_id != 16) {
              this.tipo_tramite.push(response.data.entities[key]);
            }
          } */
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },
    goPage(flujo_tipo_id) {
      if (this.dparams.roluser != 7 && this.dparams.roluser != 8) {
        Service.setFlujoTipoId(flujo_tipo_id);
        if (flujo_tipo_id == 13) {  /* setear a valores de proporducción del archivo general.js para preproduccion deberia ser 13 NEKO*/
          this.$router.push({name: 'tramite_inicio'});
        } else {
          this.$router.push({name: 'tramite_apertura_subsede'});
        }
      } else {
        this.toast('warning', 'El usuario no tiene tuición para realizar el trámite seleccionado.');
      }
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  }
};
</script>